import { render, staticRenderFns } from "./enterpriseincome_kfDetail.vue?vue&type=template&id=11bf7bf4&scoped=true&"
import script from "./enterpriseincome_kfDetail.vue?vue&type=script&lang=js&"
export * from "./enterpriseincome_kfDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bf7bf4",
  null
  
)

export default component.exports